import Grid from "@material-ui/core/Grid";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {grey} from "@material-ui/core/colors";
import {FormStatus} from "../../../models/shared";
import CheckIcon from "@material-ui/icons/Check";
import WarningIcon from "@material-ui/icons/Warning";
import IconButton from "@material-ui/core/IconButton";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    actionContainer: {
        width: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    dataRow: {
        borderBottom: `1px solid ${grey[300]}`
    },
    groupDataContainer: {
        padding: theme.spacing(2),
    },
    deleteBtn: {
        color: theme.palette.error.main
    },
    successLabel: {
        color: theme.palette.success.main
    },
    prompText: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        height: theme.spacing(2)
    }
}));

interface Props {
    processingStatus: FormStatus,
    children: JSX.Element,
    handleDeleteItem?: () => void
    errorMessage?: string,
    isSingleItem?: boolean,
}

export const ValidationRow: React.FC<Props> = ({processingStatus, handleDeleteItem, errorMessage, children, isSingleItem = false}: any) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const processingFormAction = (status: FormStatus) => {
        switch (status) {
            case FormStatus.successful :
                return <CheckIcon className={classes.successLabel}/>;
            case FormStatus.failed :
                return <WarningIcon color='error'/>;
            case FormStatus.processing :
                return <CircularProgress size={20} color="inherit"/>;
            case FormStatus.deletable:
                return <IconButton aria-label="delete" className={classes.deleteBtn} onClick={handleDeleteItem}>
                    <RemoveCircle/>
                </IconButton>;
        }
    };

    return <Grid container item xs={12}>
        <Grid container item xs={12}
              justify='space-between' className={clsx(isSingleItem ? classes.groupDataContainer : classes.dataRow)}>
            {children}
            <Grid item className={classes.actionContainer}>
                {processingFormAction(processingStatus)}
            </Grid>
        </Grid>
        {errorMessage && processingStatus === FormStatus.failed &&
        <Grid item xs={12} md={6} className={classes.prompText}>
            <Typography variant='caption' color='error'>{t(`${errorMessage}`)}</Typography>
        </Grid>}
    </Grid>
}
